import { css } from 'linaria';

export const interiorDoorsGallery = css`
  && {
    @media (--only-tablet) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
  }
`;

export const interiorDoorsGalleryImage = css`
  && {
    @media (--to-desktop) {
      height: 216px;
    }

    &:nth-of-type(4),
    &:nth-of-type(9),
    &:nth-of-type(11) {
      grid-column-start: 1;
    }

    &:nth-of-type(5n),
    &:nth-of-type(11) {
      height: 784px;

      @media (--from-tablet) {
        grid-row-start: span 2;
      }

      @media (--only-tablet) {
        height: 456px;
      }

      @media (--only-mobile) {
        height: 454px;
      }
    }
  }
`;
